import React, { ReactNode, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import LeftNavigationBar from 'screens/Main/components/LeftNavigationBar';
import TopNavigationBar from 'screens/Main/components/TopNavigationBar';
import LoginPromptModal from 'components/LoginPromptModal';

interface Props {
  title: string;
  hero: string;
  children: ReactNode;
}

const ArticleLayout = ({ title, hero, children }: Props) => {
  const currentUser = useSelector((state: RootState) => state.auth.user);

  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Mobile detection
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsMobileMenuOpen(false);
      }
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Scroll to top when article loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Handle sidebar navigation attempts
  const handleNavigationAttempt = () => {
    if (!currentUser) {
      setShowLoginModal(true);
    }
  };

  return (
    <div className="article-layout">
      {/* Mobile Menu Overlay - click to close */}
      {isMobile && isMobileMenuOpen && (
        <div
          className="article-mobile-menu-overlay"
          onClick={() => setIsMobileMenuOpen(false)}
          aria-hidden="true"
        />
      )}

      <div className="article-content-wrapper">
        <LeftNavigationBar
          currentTab={{ path: '/articles', Component: <></> }}
          isPublicMode={!currentUser}
          onNavigationAttempt={handleNavigationAttempt}
          isAuthenticated={!!currentUser}
          isMobile={isMobile}
          isMobileMenuOpen={isMobileMenuOpen}
          onMenuClose={() => setIsMobileMenuOpen(false)}
        />

        <div className="article-main">
          {/* Top Navigation Bar */}
          <TopNavigationBar
            title="Articles"
            isMobileMenuOpen={isMobileMenuOpen}
            onToggleMobileMenu={toggleMobileMenu}
          />

          <div className="article-container">
            <header
              className="article-hero"
              style={{ backgroundImage: `url(${hero})` }}
            >
              <div className="article-overlay" />
              <h1 className="article-title">{title}</h1>
            </header>
            {children}
          </div>
        </div>
      </div>

      <LoginPromptModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        collectionOwnerUsername=""
      />
    </div>
  );
};

export default ArticleLayout;
